import { qidaApi } from '../api';
/**
 * @description: 获取要素与功能清单
 * @param {Array<string>} factorCodes 要素code集合
 * @param {Array<string>} funcCodes 功能点code集合
 * @return {*} 返回要素与功能关系集合清单
 */

export var GetFactors = function GetFactors(orgId, funcCodes, factorCodes) {
  return qidaApi.post('factors/auth', {
    factorCodes: factorCodes,
    funcCodes: funcCodes,
    orgId: orgId
  });
};
/**
 * @description: 根据机构id获取该机构下全部要素与功能清单
 * @param {Array<string>} orgId 机构id
 * @return {*} 返回要素与功能关系集合清单
 */

export var GetFactorsByOrgId = function GetFactorsByOrgId(orgId) {
  return qidaApi.get("/factors/" + orgId + "/func-points");
};
/**
 * @description: 根据机构id获取该机构下要素的版本号
 * @param {Array<string>} orgId 机构id
 * @return {*} 版本号
 */

export var GetAuthVersionByOrgId = function GetAuthVersionByOrgId(orgId) {
  return qidaApi.get("/factors/" + orgId + "/func-points/refresh/check");
};